import script from "./AssigneeBar.vue?vue&type=script&setup=true&lang=js"
export * from "./AssigneeBar.vue?vue&type=script&setup=true&lang=js"

import "./AssigneeBar.vue?vue&type=style&index=0&id=00fa6be6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00fa6be6"]])

export default __exports__